export enum TaxIdRequirement {
  REQUIRED,
  OPTIONAL,
  // Neither optional nor required
  NONE,
}
